<template>
	<sf-button v-if="isButton_(scrId, 'AD')" :onClick="openModal">{{ getButtonMsg_(scrId, 'AD') }}</sf-button>
</template>
<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/TableDataManagement/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,

		openModal() {
			this.tableDataManagementModalValue.flg = 'I';
			this.defaultAssign_({ key: 'TableDataManagementModal', value: true });
		}
	}
};
</script>
<style></style>
